/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import React from "react";
import { DateInput } from "@progress/kendo-react-dateinputs";
import { Input } from "@repo/ui";
import styles from "./add-new-asset.module.scss";

function AssetDetailsCard({ asset }: any) {
  return (
    <>
      <div className={styles.adduserBox}>
        <div className={styles.adduserInputs}>
          <label className="font-medium leading-none">Cash Center</label>
          <Input className="w-full" value={asset.cashCenter} disabled />
        </div>
        <div className={styles.adduserInputs}>
          <label className="font-medium leading-none">Office</label>
          <Input className="w-full" value={asset.officeName} disabled />
        </div>
      </div>

      <div className={styles.adduserBox}>
        <div className={styles.adduserInputs}>
          <label className="font-medium leading-none">Description</label>
          <Input className="w-full" value={asset.description} disabled />
        </div>
        <div className={styles.adduserInputs}>
          <label className="font-medium leading-none">Asset Type</label>
          <Input className="w-full" value={asset.assetType} disabled />
        </div>
      </div>

      <div className={styles.adduserBox}>
        <div className={styles.adduserInputs}>
          <label className="font-medium leading-none">Asset No</label>
          <Input className="w-full" value={asset.assetNo} disabled />
        </div>
        <div className={styles.adduserInputs}>
          <label className="font-medium leading-none">Serial No</label>
          <Input className="w-full" value={asset.serialNo} disabled />
        </div>
      </div>

      <div className={styles.adduserBox}>
        <div className={styles.adduserInputs}>
          <label className="font-medium leading-none">Model</label>
          <Input className="w-full" value={asset.model} disabled />
        </div>
        <div className={styles.adduserInputs}>
          <label className="font-medium leading-none">Brand</label>
          <Input className="w-full" value={asset.brand} disabled />
        </div>
      </div>

      <div className={styles.adduserBox}>
        <div className={styles.adduserInputs}>
          <label className="font-medium leading-none">Issued To</label>
          <Input className="w-full" value={asset.employeeId} disabled />
        </div>
        <div className={styles.adduserInputs}>
          <label className="font-medium leading-none">Issued By</label>
          <Input className="w-full" value={asset.issuedBy} disabled />
        </div>
      </div>

      <div className={styles.adduserBox}>
        <div className={styles.adduserInputs}>
          <label className="font-medium leading-none">Issued Date</label>

          <DateInput
            disabled
            value={
              asset.issuedDate ? new Date(asset.issuedDate as string) : null
            }
            className="w-full"
            format="dd-MMM-yyyy"
          />
        </div>
        <div className={styles.adduserInputs}>
          <label className="font-medium leading-none">Returned Date</label>
          <DateInput
            disabled
            value={
              asset.returnedDate ? new Date(asset.returnedDate as string) : null
            }
            className="w-full"
            format="dd-MMM-yyyy"
          />
        </div>
      </div>

      <div className={styles.adduserBox}>
        <div className={styles.adduserInputs}>
          <label className="font-medium leading-none">Received By</label>
          <Input className="w-full" value={asset.receivedBy} disabled />
        </div>
        <div className={styles.adduserInputs}>
          <label className="font-medium leading-none">Status</label>
          <Input className="w-full" value={asset.status} disabled />
        </div>
      </div>

      <div className={styles.adduserBox}>
        <div className={styles.adduserInputs}>
          <label className="font-medium leading-none">Remarks</label>
          <Input className="w-full" value={asset.remarks} disabled />
        </div>
      </div>
    </>
  );
}

export default AssetDetailsCard;
